<div class="mat-elevation-z8">
  <table mat-table [dataSource]="dataSource" matSort>
    <ng-container matColumnDef="name">
      <th class="name-column" mat-header-cell *matHeaderCellDef mat-sort-header> Nome </th>
      <td class="name-column" mat-cell *matCellDef="let row"> {{row.name}} </td>
    </ng-container>

    <ng-container matColumnDef="email">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Email </th>
      <td mat-cell *matCellDef="let row"> {{row.email}} </td>
    </ng-container>

    <ng-container matColumnDef="organizations">
      <th mat-header-cell *matHeaderCellDef> Gabinetes </th>
      <td mat-cell *matCellDef="let row"> {{getOrgNames(row)}} </td>
    </ng-container>

    <ng-container matColumnDef="impersonate">
      <th class="open-column" mat-header-cell *matHeaderCellDef></th>
      <td class="open-column" mat-cell *matCellDef="let row">
        <button [matTooltip]="'Visualizar como este usuário'" mat-icon-button (click)="impersonateUser(row)" [disabled]="!row.organizations?.length">
          <mat-icon fontIcon="visibility"></mat-icon>
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

    <tr class="mat-row" *matNoDataRow>
      <td class="mat-cell" colspan="4">Nenhum usuário encontrado</td>
    </tr>
  </table>
  <mat-paginator [pageSize]="10" [pageSizeOptions]="[5, 10, 25, 100]" aria-label="Selecione a página dos usuários"></mat-paginator>
</div>
